export const resolvePlaceholder = (
  inlineValue: string | undefined,
  tenantValue: string | undefined,
  bundleDefault: string,
): string => inlineValue?.trim() || tenantValue?.trim() || bundleDefault;
